<template>
	<div class="upload">
		<el-upload action="" :file-list="fileList" :on-change="handleChange" :accept="accept" :auto-upload="false" :multiple="multiple" :limit="limit" :show-file-list="false">
			<el-button size="mini" type="primary" slot="trigger" :disabled="fileList.length >= limit">上傳輔導員</el-button>
			<small slot="tip"><br>只能上傳CSV</small>
		</el-upload>
		<el-dialog :visible="visible" :before-close="() => previewUrl = ''">
			<img :src="previewUrl" width="100%">
		</el-dialog>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	props: {
		"media-folder": String,
		"file-list": {
			type: Array,
			default: () => new Array
		},
		multiple: Boolean,
		limit: Number,
		accept: {
			type: String,
			default: () => "image/*"
		},
	},
	model: {
		prop: "file-list",
		event: "change"
	},
	data() {
		return {
			previewUrl: ""
		}
	},
	computed: {
		visible() {
			return this.previewUrl ? true : false;
		}
	},
	methods: {
		...mapActions("merrymama-user", ["uploadMerryMamaUser"]),
		async handleChange({ raw }, fileList) {
			const data = new FormData();
			data.append("file", raw);
			try {
				const { message } = await this.uploadMerryMamaUser(data)
				this.$message.success(message);
			} catch (error) {
				this.$message.error(error.message);
			}
		},
	}
}
</script>